import { contexts } from 'constants/context';

const contextsThatHideHeader = [contexts.login, contexts.authentication];
const contextsThatHideSidebar = [contexts.login, contexts.authentication];
const contextsThatDontRequireStaticData = [
  contexts.login,
  contexts.authentication,
  contexts.dashboard,
];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
  contextsThatDontRequireStaticData,
};

export default hideElements;
